"use strict";
var configPromise = require('../config').configPromise;
var Api = require('./api');

var ACCOUNT_URL = '/api/account';
var URL_ACT_AS_QUERY = "/actAs";
var ROLES = "/api/account/roles";
var PERMISSIONS = "/api/account/permissions";
var SETTINGS = "/api/account/settings";

/**
 * Account api
 * @type {{getAccount: AccountApi.getAccount, updateAccount: AccountApi.updateAccount}}
 */
var AccountApi = {

  /**
   * Get account
   * GET api/Account
   * @returns {*} account data
   */
  getAccount: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ACCOUNT_URL));
      });
  },

  /**
   * Update account
   * PUT api/Account
   * @param data account data
   * @returns {*} identifier of updated account
   */
  updateAccount: function (data) {
    return configPromise
      .then(function (config) {
        return Api.put(config.apiPath(ACCOUNT_URL), data);
      })
      .catch(function (error) {
        throw error;
      });
  },

  /**
   * POST api/account/actAs
   * @param userId user identifier
   * @returns {*} link for redirection
   */
  actAsAccount: function (data) {
    return configPromise
      .then(function (config) {
        return Api.post(config.apiPath(ACCOUNT_URL + URL_ACT_AS_QUERY), data);
      })
      .catch(function (error) {
        throw error;
      });
  },

  getRoles: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ROLES));
      });
  },

  getPermissions: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(PERMISSIONS));
      });
  },

  async getSetting(keys) {
    const config = await configPromise;
    return Api.get(config.apiPath(SETTINGS), { keys });
  },

  async patchSettings(keyValuePairs) {
    const config = await configPromise;
    return Api.patch(config.apiPath(SETTINGS), keyValuePairs);
  }


};
module.exports = AccountApi;
